import script from "./HackathonFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./HackathonFilters.vue?vue&type=script&setup=true&lang=js"

import "./HackathonFilters.vue?vue&type=style&index=0&id=719cc119&scope=true&lang=scss"

export default script